import React from 'react';
import LabeledDatePicker from'../../base/LabeledDatePicker/LabeledDatePicker';

const PurchaseDate = ({label,onChange,selectedDate}) => {

    return (
        <LabeledDatePicker
            className="col-xs-12"
            id="fault-date"
            inputDivClassName="col-xs-12 col-sm-12"
            name="articlePurchaseDate"
            label={label}
            onChange={onChange}
            selectedDate={selectedDate} />
    );
}

export default PurchaseDate;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionComponents/PurchaseDate/PurchaseDate.js